import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ComponentInterface } from '../../../fc-core/src/component-interface';
import { toRaphaelColor, pluck, pluckNumber } from '../../../fc-core/src/lib';
import { addDep } from '../../../fc-core/src/dependency-manager';
import crosslineAnimation from './crossline.animation';
var M = 'M',
    L = 'L',
    DEFAULTCOLOR = '#EEEEEE',
    DEFAULTALPHA = 50,
    BAND = 'band';

var CrossLine =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(CrossLine, _ComponentInterface);

  function CrossLine() {
    var _this;

    _classCallCheck(this, CrossLine);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CrossLine).call(this)), addDep({
      name: 'crosslineAnimation',
      type: 'animationRule',
      extension: crosslineAnimation
    });
    return _this;
  }

  _createClass(CrossLine, [{
    key: "getName",
    value: function getName() {
      return 'crossline';
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'crossline';
    }
  }, {
    key: "show",
    value: function show() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = this,
          c = !!a.onTop,
          d = a.type,
          e = b.config.prevRenderedOnTop;
      c === e || b.hide(), b[d] || (d = BAND), b[d](a), b.config.prevRenderedOnTop = c;
    }
  }, {
    key: "band",
    value: function band() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b,
          c,
          d = this,
          e = a.managerId,
          f = a.x1,
          g = a.y1,
          h = a.x2,
          i = a.y2,
          j = a.thickness,
          k = !!a.onTop,
          l = pluck(a.fillcolor, DEFAULTCOLOR),
          m = pluckNumber(a.alpha, DEFAULTALPHA),
          n = toRaphaelColor({
        color: l,
        alpha: m
      }),
          o = d.getLinkedParent().getChildContainer('crosslineBottom'),
          p = d.getLinkedParent().getChildContainer('crosslineTop');
      c = k ? p : o, b = d.getGraphicalElement('crosslineBand' + e), b ? a.animDuration ? b.animate({
        path: [M, f, g, L, h, i]
      }, a.animDuration, 'ease-in') : b.attr({
        path: [M, f, g, L, h, i]
      }) : d.addGraphicalElement('crosslineBand' + e, d.getFromEnv('paper').path({
        path: [M, f, g, L, h, i],
        stroke: n,
        fill: n,
        "stroke-width": j,
        "stroke-linecap": 'butt'
      }, c));
    }
  }, {
    key: "hide",
    value: function hide() {
      var a = this.getGraphicalElement(),
          b = Object.keys(a);

      for (var c = b.length - 1; -1 < c; c--) {
        a[b[c]].stop(void 0, !0, !0), a[b[c]].remove(), delete a[b[c]];
      }
    }
  }]);

  return CrossLine;
}(ComponentInterface);

export default CrossLine;